/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { getAuthorizationHeader } from 'utils/Helpers'
import { RequestContentType } from 'utils/Helpers'

const ApiKeyAPI = Marty.createStateSource({
  id: 'ApiKeyAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CUSTOMER_API,

  getApiKeyByOrgId(orgId) {
    return this.get({
      url: `/organizations/${orgId}/api_keys`,
      headers: getAuthorizationHeader()
    })
  },

  createApiKeyForOrgId(orgId) {
    return this.post({
      url: `/organizations/${orgId}/api_keys`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify({ isProd: true })
    })
  }
})

export default ApiKeyAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/ApiKeyAPI.js